package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class Name(
    val name: String,
    val id: Int? = null
)